import { Box, styled } from '@mui/material';

export const TextW = styled(Box)`
  width: 467px;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  margin-top: 12px;
  color: ${({ theme }) => theme.palette.primary.p050};
  white-space: pre-line;

  @media (max-width: 1023px) {
    font-size: 15px;
    width: 100%;
    margin-top: 8px;
  }
`;
